<template>
  <v-app-bar clipped-left app dense color="#D199FB" dark style="z-index: 4;">
    <img
      height="30"
      src="../assets/SefLinkLogo.svg"
      alt="SEF Link Plus logo"
      onclick="goToHome()"
      style="cursor: pointer;"
    />
    <v-toolbar-title link @click="goToHome()" style="cursor:pointer;" class="ml-2 mt-1 black--text font-weight-bold">Admin</v-toolbar-title>
    <v-spacer />
    <v-btn class="button-class" @click="logout()" v-if="this.$store.getters.isLoggedIn === true">
      Log out
      <v-icon>mdi-logout</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import firebase from "firebase";

export default {
  name: 'Toolbar',
  methods: {
    logout () {
      this.$store.commit('token', null)
      firebase.auth().signOut().then(() => {
        firebase.auth().onAuthStateChanged(() => {
          this.goToHome();
        })
      })
    },
    goToHome () {
      if (this.$router.currentRoute.path !== '/') {
        this.$router.push('/')
        return
      }

      if (this.$store.getters.isLoggedIn === false
        && this.$router.currentRoute.path !== '/login') {
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style scoped>
.button-class{
  margin-left: 10px;
  margin-right: 10px;
}
</style>
